import { isEmpty } from "lodash";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useContext } from "react";
import BetSlipContext from "../../context/BetSlipContext";
import Keyboard from "./Keyboard";
import { BetCategoryTabs } from "./MarketTabs";

const Fancy = ({
  betType,
  data,
  details,
  slipObj,
  setSlipObj,
  fancyCategory,
  setSelectedTabFunc,
  selectedTab,
  profileData,
  user,
  resetSelection,
  isTv,
  setIsTv,
  key,
  messaageBox,
  loader,
  fancyList,
  isDesktop,
}) => {
  const myRef = useRef(null);
  const [id, setId] = useState("");
  const [id2, setId2] = useState("");
  const handleScroll = () => {
    setId("");
    setId2("");
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // console.log(data?.length)
  useEffect(() => {
    if (!isEmpty(id)) {
      myRef.current.scrollIntoView(true);
    }
  }, [id]);

  const [amountRange, setAmountRange] = useState({
    min: 0,
    max: 0,
    oddsLimit: 0,
    betDelay: 0
  });

  useEffect(() => {
    let obj = profileData?.matchSetting?.find(
      (res) =>
        res?.type == betType &&
        (profileData?.arrayCheck == "details"
          ? true
          : res?.sportType == details?.gameType)
    );
    if (!isEmpty(obj)) {
      setAmountRange({
        min: Number(obj?.minAmount) || 0,
        max: Number(obj?.maxAmount) || 0,
        oddsLimit: obj.oddsLimit ? obj.oddsLimit : 0,
        betDelay: obj?.betDelay
      });
    } else {
      // Feed-sourced events have no matching `matchSetting` entry, so
      // amountRange stayed {min:0,max:0} and the Place Bet button was
      // permanently disabled (bidPrice <= max=0 is always false). Fall back
      // to the market's own min/max from the match-detail feed so fancy bets
      // can actually be placed.
      setAmountRange({
        min: Number(details?.minAmount) || 10,
        max: Number(details?.maxAmount) || 500000,
        oddsLimit: 0,
        betDelay: 0,
      });
    }
  }, [profileData, user, details, betType]);
  const [popupMessage, setPopupMessage] = useState({
    check: false,
    id: "",
  });

  let {
    betSelectionObj,
    setBetSelectionObj,
    setBetFairObj,
    defaultStake,
    defaultOdds,
    setBookPosition,
    setBookPositionData,
  } = useContext(BetSlipContext);
  useEffect(() => {
    if (
      betSelectionObj?.betType == "fancy" &&
      id &&
      isEmpty(data?.find((res) => res?.selectionId == id)?.odds)
    ) {
      setBetSelectionObj({});
      setBetFairObj({});
      setPopupMessage({ check: false, id: "" });
    }
  }, [betSelectionObj, data]);

  return fancyList?.length > 0 ? (
    <>
      <style>{fancyHeadStyles}</style>
      <BetCategoryTabs
        tabs={[
          { type: "All", name: "ALL" },
          { type: "Fancy", name: "Fancy" },
          { type: "LineMarket", name: "Line Market" },
          { type: "BallByBall", name: "Ball by Ball" },
          { type: "Meter", name: "Meter" },
          { type: "Khado", name: "Khado" },
        ]}
        active={selectedTab}
        onSelect={setSelectedTabFunc}
        label="Fancy Bet categories"
      />
      <div id="fancyBetTag">
        {/* {console.log(data?.length)} */}
        {data?.length > 0 && (
          isDesktop ? (
            <dl class="bets-selections-head fancy-head fancy-head-desktop" style={{ background: "#fff" }}>
              <dt></dt>
              <dd class="fancy-head-book"></dd>
              <dd class="fancy-head-no">No</dd>
              <dd class="fancy-head-yes">Yes</dd>
              <dd class="fancy-head-minmax">Min/Max</dd>
            </dl>
          ) : (
            <dl class="bets-selections-head fancy-head" style={{ background: "#fff" }}>
              <dt></dt>
              <dd class="mode-land"></dd>
              <dd class="mode-land"></dd>
              <dd class="fancy-head-no">No</dd>
              <dd class="fancy-head-yes">Yes</dd>
              <dd class="mode-land"></dd>
              <dd class="mode-land"></dd>
            </dl>
          )
        )}
        {data?.length > 0 &&
          [...data]?.sort((a, b) => Number(a?.srno) - Number(b?.srno))?.map((item, index) => {
            
            if (
              item?.odds?.ms == 4 ||
              item?.odds?.rt?.length == 0 ||
              item?.odds?.ms == 2 ||
              isEmpty(item?.odds?.rt)
            ) {
              return null;
            } else {
              let newPosition = "";
              if (slipObj?.name === item?.name) {
                if (slipObj?.ib) {
                  if (Math.abs(item?.position) > 0) {
                    let backLoss = Number(betSelectionObj?.bidPrice) + Number(item.position);
                    newPosition = Number(backLoss);
                  } else {
                    let backLoss = Number(betSelectionObj?.bidPrice);
                    newPosition = Number(backLoss);
                  }
                } else {
                  if (Math.abs(item?.position) > 0) {
                    let backProfit =
                      (Number(betSelectionObj?.bidPrice) * Number(slipObj?.pt)) / 100;
                      newPosition = Number(backProfit) + Number(item.position)
                  } else {
                    let backProfit =
                      (Number(betSelectionObj?.bidPrice) * Number(slipObj?.pt)) / 100;
                    newPosition = Number(backProfit)
                  }
                }
              }
              let condition =
                slipObj?.name === item?.name &&
                betSelectionObj?.priceToogle &&
                betSelectionObj?.betType == "fancy" &&
                Math.abs(newPosition) > 0;
              return (
                <div
                  ref={item.selectionId == id && index == id2 ? myRef : null}
                  className={`bets-wrap fancy-bet ${
                    isDesktop ? "fancy-bet-desktop" : ""
                  } ${
                    details.fancy == "off" ? "disabled" : ""
                  }`}
                >
                  <dl className="bets-selections">
                    <dt class="line_market-selection">
                      <div className="fancy-name-cell">
                        <span id="marketName">{item.fancyName}</span>
                        <a
                          href="javascript:void(0)"
                          onClick={() =>
                            setPopupMessage({
                              check: true,
                              id: item.selectionId,
                            })
                          }
                          id="open-fancy_info"
                          className="btn-fancy_info"
                        >
                          fancybet info
                        </a>
                        {popupMessage.check &&
                          item.selectionId == popupMessage.id && (
                            <div
                              id="fancy_popup2"
                              style={{
                                display: "flex",
                                zIndex: 10,
                              }}
                              className="fancy_info-popup"
                            >
                              <dl>
                                <dt>Min / Max</dt>
                                <dd id="minMax">
                                  {" "}
                                  {amountRange?.min?.toFixed(2)} /{" "}
                                  {amountRange?.max?.toFixed(2)}
                                </dd>
                              </dl>
                              <dl>
                                <dt id="rebateName" style={{ display: "none" }}>
                                  Rebate
                                </dt>
                                <dd id="rebate" style={{ display: "none" }}></dd>
                              </dl>
                              <a
                                href="javascript:void(0)"
                                onClick={() =>
                                  setPopupMessage({
                                    check: false,
                                    id: "",
                                  })
                                }
                                id="close-fancy_info"
                                className="close"
                              >
                                Close
                              </a>
                            </div>
                          )}
                      </div>
                      <div className="tips" style={{ display: "flex", flexWrap: "wrap", width: "100%", margin: "4px 0 0", padding: 0, justifyContent: "flex-start", textAlign: "left", fontSize: "12px", lineHeight: 1.2 }}>
                          {(Math.abs(item?.position) > 0 ||
                            Math.abs(newPosition) > 0) &&
                            Math.abs(item?.position) > 0 && (
                              <span
                                id="before"
                                style={{ marginRight: "5px" }}
                                class="lose"
                              >
                                (
                                {parseFloat(Math.abs(item.position)).toFixed(2)}
                                )
                              </span>
                            )}
                          {Math?.abs(newPosition) > 0 && condition && (
                            <span
                              id="after"
                              className="to-lose"
                              style={{ display: "inline-block", textAlign: "left" }}
                            >
                              ({parseFloat(Math.abs(newPosition)).toFixed(2)})
                            </span>
                          )}
                      </div>
                    
                      {(item?.position != "" || item?.position === 0) &&
                        !isNaN(Math.abs(item?.position)) && (
                          <a
                            id="fancyBetBookBtn"
                            href="javascript:void(0)"
                            className="btn-book"
                            onClick={() => {
                              setBookPosition(true);
                              // setIsTv({ ...isTv, status: false });
                              setBookPositionData(item);
                            }}
                          >
                            Book
                          </a>
                        )}
                    </dt>

                    {isDesktop && (
                      <dd className="fancy-book-col">
                        <a
                          href="javascript:void(0)"
                          className="btn-book-desktop"
                          onClick={() => {
                            setBookPosition(true);
                            setBookPositionData(item);
                          }}
                        >
                          Book
                        </a>
                      </dd>
                    )}

                    {item?.odds?.ms == 1 ? (
                      ""
                    ) : (
                      <dd
                        id="suspend"
                        className="suspend-fancy"
                        style={{ display: "flex" }}
                      >
                        <p id="info">
                          {item?.odds?.ms == 9
                            ? "Ball Running"
                            : item?.odds?.ms == 2
                            ? "In Active"
                            : item?.odds?.ms == 3
                            ? "Suspended"
                            : item?.odds?.ms == 4
                            ? "Closed"
                            : ""}
                        </p>
                      </dd>
                    )}
                    {loader &&
                    betSelectionObj?.betType == "fancy" &&
                    slipObj.ri == item.selectionId ? (
                      <dd id="delayBetting" class="suspend-fancy">
                        <p id="info"></p>
                      </dd>
                    ) : (
                      ""
                    )}
                    
                    <dd
                      id="lay_1"
                      onClick={() => {
                        if (
                          !item?.odds?.rt[0]?.rt ||
                          details.fancy == "off" ||
                          details?.sport_setting?.status == "inActive"
                        ) {
                        } else {
                          if (!messaageBox) {
                            if (betSelectionObj.betType !== betType) {
                              resetSelection(betSelectionObj.betType);
                            }
                            setId(item.selectionId);
                            setId2(index);
                            setBetSelectionObj({
                              ...betSelectionObj,
                              betType: betType,
                              oddsSelect: item?.odds?.rt[0]?.rt,
                              fancyOddSelect: item?.odds?.rt[0]?.pt,
                              layorback: "lay",
                              inputType: "price",
                              expectany: defaultOdds,
                              bidPrice: defaultStake == 0 ? "" : defaultStake,
                              priceToogle: true,
                              priceToogleType: "odds",
                              minAmount: amountRange.min,
                              maxAmount: amountRange.max,
                            });

                            setSlipObj({
                              ...item,
                              ...item?.odds?.rt[0],
                              rt: item?.odds?.rt[0]?.rt,
                              pt: item?.odds?.rt[0]?.pt,
                              runnerName: item?.jsonData[0]?.runnerName,
                            });
                          }
                        }
                      }}
                      style={
                        !item?.odds?.rt[0]?.rt || details?.fancy == "off"
                          ? { cursor: "not-allowed" }
                          : { cursor: "pointer" }
                      }
                      className={
                        !item?.odds?.rt[0]?.rt ||
                        details?.fancy == "off" ||
                        details?.sport_setting?.status == "inActive"
                          ? "single-disabled"
                          : ""
                      }
                    >
                      <a
                        className={
                          item?.odds?.rt[0]?.rt == slipObj?.rt &&
                          item?.odds?.rt[0]?.pt == slipObj?.pt &&
                          slipObj.ri == item.selectionId &&
                          betSelectionObj?.priceToogle
                            ? `lay-1 select ${
                                Number(
                                  document.getElementById("odds1")?.name
                                ) !== item?.odds?.rt[0]?.rt && "spark"
                              }`
                            : `lay-1 ${
                                Number(
                                  document.getElementById("odds1")?.name
                                ) !== item?.odds?.rt[0]?.rt && "spark"
                              }`
                        }
                        id={"odds1"}
                        name={item?.odds?.rt[0]?.rt}
                        href="javascript:void(0)"
                      >
                        {item?.odds?.rt?.length > 0
                          ? item?.odds?.rt[0]?.rt
                          : !isEmpty(item?.odds?.temp) &&
                            item?.odds?.temp[0]?.rt}
                        {/* {vart1} */}
                        <span>
                          {item?.odds?.rt?.length > 0
                            ? item?.odds?.rt[0]?.pt
                            : !isEmpty(item?.odds?.temp) &&
                              item?.odds?.temp[0]?.pt}
                        </span>
                      </a>
                    </dd>
                    <dd
                      id="back"
                      onClick={() => {
                        if (
                          !item?.odds?.rt[1]?.rt ||
                          details?.fancy == "off" ||
                          details?.sport_setting?.status == "inActive"
                        ) {
                        } else {
                          if (!messaageBox) {
                            if (betSelectionObj.betType !== betType) {
                              resetSelection(betSelectionObj.betType);
                            }
                            setId(item.selectionId);
                            setId2(index);
                            setBetSelectionObj({
                              ...betSelectionObj,
                              betType: betType,
                              oddsSelect: item?.odds?.rt[1]?.rt,
                              layorback: "back",
                              inputType: "price",
                              bidPrice: defaultStake == 0 ? "" : defaultStake,
                              fancyOddSelect: item?.odds?.rt[1]?.pt,
                              priceToogle: true,
                              priceToogleType: "odds",
                              minAmount: amountRange.min,
                              expectany: defaultOdds,
                              maxAmount: amountRange.max,
                            });
                            setSlipObj({
                              ...item,
                              ...item?.odds?.rt[1],
                              rt: item?.odds?.rt[1]?.rt,
                              pt: item?.odds?.rt[1]?.pt,
                              runnerName: item?.jsonData[0]?.runnerName,
                            });
                          }
                        }
                      }}
                      style={
                        !item?.odds?.rt[1]?.rt ||
                        details?.fancy == "off" ||
                        details?.sport_setting?.status == "inActive"
                          ? { cursor: "not-allowed" }
                          : { cursor: "pointer" }
                      }
                      className={
                        !item?.odds?.rt[1]?.rt ||
                        details?.fancy == "off" ||
                        details?.sport_setting?.status == "inActive"
                          ? "single-disabled"
                          : ""
                      }
                    >
                      <a
                        className={
                          item?.odds?.rt[1]?.rt == slipObj?.rt &&
                          item?.odds?.rt[1]?.pt == slipObj?.pt &&
                          slipObj.ri == item.selectionId &&
                          betSelectionObj?.layorback == "back" &&
                          betSelectionObj?.priceToogle
                            ? `back-1 select ${
                                Number(
                                  document.getElementById("odds2")?.name
                                ) !== item?.odds?.rt[1]?.rt && "spark"
                              }`
                            : `back-1 ${
                                Number(
                                  document.getElementById("odds2")?.name
                                ) !== item?.odds?.rt[1]?.rt && "spark"
                              }`
                        }
                        id={"odds2"}
                        name={item?.odds?.rt[1]?.rt}
                        href="javascript:void(0)"
                      >
                        {item?.odds?.rt?.length > 0
                          ? item?.odds?.rt[1]?.rt
                          : !isEmpty(item?.odds?.temp) &&
                            item?.odds?.temp[1]?.rt}
                        <span>
                          {item?.odds?.rt?.length > 0
                            ? item?.odds?.rt[1]?.pt
                            : !isEmpty(item?.odds?.temp) &&
                              item?.odds?.temp[1]?.pt}
                        </span>
                      </a>
                    </dd>
                    {isDesktop && (
                      <dd className="fancy-minmax-col">
                        {`${Number(item?.min ?? amountRange?.min ?? 0)} - ${Number(item?.max ?? amountRange?.max ?? 0)}`}
                      </dd>
                    )}
                  </dl>
                  {betSelectionObj?.priceToogle &&
                    betSelectionObj?.betType == "fancy" &&
                    slipObj.ri == item.selectionId &&
                    item?.odds?.ms == "1" && (
                      <Keyboard
                        setSlipObj={setSlipObj}
                        details={details}
                        slipObj={slipObj}
                        amountRange={amountRange}
                        betType={betType}
                        resetSelection={resetSelection}
                      />
                    )}
                </div>
              );
            }
          })}
        {isEmpty(data) && (
          <div id="noGameWrap" class="bets-wrap">
            <p class="no-game">
              Fancybet market will be available after event In-Play
            </p>
          </div>
        )}
      </div>
    </>
  ) : (
    <div id="noGameWrap" class="bets-wrap">
      <p class="no-game">
        Fancybet market will be available after event In-Play
      </p>
    </div>
  );
};

const fancyHeadStyles = `
/* The fancy market name now lives inside the odds row's left cell (dt), so the
   name + info + No/Yes all sit on ONE row (matches the reference). */
#fancyBetTag .fancy-bet .bets-selections > dt.line_market-selection{
  flex:1 1 auto;
  width:auto;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:flex-start;
}
#fancyBetTag .fancy-bet .fancy-name-cell{
  display:flex;
  align-items:center;
  gap:2vw;
  width:100%;
}
#fancyBetTag .fancy-bet .fancy-name-cell #marketName{
  font-weight:700;
  font-size:12px;
  line-height:1.2;
  color:#1e1e1e;
}
#fancyBetTag .fancy-bet .fancy-name-cell .btn-fancy_info{
  margin-left:auto;
}
/* black info (i) icon */
#fancyBetTag .fancy-bet .fancy-name-cell .btn-fancy_info:before{
  background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="%23000000" fill-rule="evenodd" d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"/></svg>') no-repeat !important;
  background-size:contain !important;
}

/* Fancy header: No = pink, Yes = blue (match the odds cells below). */
.fancy_bet_tab-wrap + #fancyBetTag .fancy-head .fancy-head-no,
#fancyBetTag .fancy-head .fancy-head-no{
  background:#faa9ba;
  color:#1a1a1a;
  font-weight:700;
  text-align:center;
  display:flex;
  align-items:center;
  justify-content:center;
}
#fancyBetTag .fancy-head .fancy-head-yes{
  background:#72bbef;
  color:#1a1a1a;
  font-weight:700;
  text-align:center;
  display:flex;
  align-items:center;
  justify-content:center;
}

/* ===================== DESKTOP FANCY LAYOUT ===================== */
/* Columns: [ name (flex) ][ Book 110px ][ No 90px ][ Yes 90px ][ Min/Max 130px ] */

/* Header row (desktop) */
#fancyBetTag .fancy-head-desktop{
  display:flex;
  align-items:stretch;
  min-height:26px;
  background:#fff;
  border-bottom:1px solid #cfcfcf;
}
#fancyBetTag .fancy-head-desktop > dt{
  flex:1 1 auto;
  border-right:0;
}
#fancyBetTag .fancy-head-desktop > dd{
  flex:0 0 auto;
  display:flex;
  align-items:center;
  justify-content:center;
  font-weight:700;
  font-size:12px;
  padding:0 !important;
  min-height:0 !important;
}
#fancyBetTag .fancy-head-desktop > dt{
  padding:0 8px !important;
  min-height:0 !important;
}
#fancyBetTag .fancy-head-desktop .fancy-head-book{ width:120px; }
#fancyBetTag .fancy-head-desktop .fancy-head-no{ width:80px; background:#faa9ba; color:#1a1a1a; }
#fancyBetTag .fancy-head-desktop .fancy-head-yes{ width:80px; background:#72bbef; color:#1a1a1a; }
#fancyBetTag .fancy-head-desktop .fancy-head-minmax{ width:135px; color:#2b6cb0; }

/* Data row (desktop) */
#fancyBetTag .fancy-bet-desktop .bets-selections{
  display:flex;
  align-items:stretch;
  min-height:0 !important;
  height:38px;
  border-bottom:1px solid #d9dede;
}
/* smaller price text inside No/Yes cells */
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#lay_1 a,
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#back a{
  padding:0 !important;
  min-height:0 !important;
  height:100%;
  font-size:14px;
  line-height:1.05;
}
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#lay_1 a span,
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#back a span{
  font-size:11px;
  line-height:1.05;
}
#fancyBetTag .fancy-bet-desktop .bets-selections > dt.line_market-selection{
  flex:1 1 auto;
  min-width:0;
  justify-content:center;
}
#fancyBetTag .fancy-bet-desktop .fancy-name-cell #marketName{
  font-size:13px;
}
/* hide the inline (i) popup trigger + in-name Book on desktop (use the column) */
#fancyBetTag .fancy-bet-desktop .fancy-name-cell .btn-fancy_info{ display:none; }
#fancyBetTag .fancy-bet-desktop > .bets-selections > dt .btn-book{ display:none; }

/* middle Book column */
#fancyBetTag .fancy-bet-desktop .fancy-book-col{
  flex:0 0 110px;
  width:110px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-right:0;
  background:#fff;
  padding:0 !important;
}
#fancyBetTag .fancy-bet-desktop .btn-book-desktop{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  width:auto;
  min-width:0;
  height:22px;
  padding:0 16px;
  border-radius:4px;
  background:#2c3e50;
  color:#fff;
  font-size:12px;
  font-weight:700;
  text-decoration:none;
  cursor:pointer;
}
#fancyBetTag .fancy-bet-desktop .btn-book-desktop:hover{ background:#22303c; }

/* No / Yes price cells fixed width on desktop */
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#lay_1,
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#back{
  flex:0 0 80px;
  width:80px;
  padding:0 !important;
  min-height:0 !important;
  height:auto;
}
/* center the odds stack (big number on top, small size below) */
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#lay_1 a,
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#back a{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  width:100%;
  height:100%;
}

/* Min/Max column */
#fancyBetTag .fancy-bet-desktop .fancy-minmax-col{
  flex:0 0 135px;
  width:135px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:12px;
  font-weight:700;
  color:#1e1e1e;
  background:#fff;
  border-right:0;
  white-space:nowrap;
}

/* Suspended overlay: on desktop only cover the No+Yes price zone, not the whole row */
#fancyBetTag .fancy-bet-desktop .bets-selections > dd#suspend.suspend-fancy{
  position:absolute;
  right:135px;        /* leave the Min/Max column clear */
  width:160px;        /* No(80) + Yes(80) */
  top:0;
  bottom:0;
  margin:0;
  z-index:3;
}
#fancyBetTag .fancy-bet-desktop .bets-selections{
  position:relative;
}
`;

export default Fancy;
